<template>
    <main class="page">
      <AppBack></AppBack>
        <section class="section page__header">
            <h1 class="title">{{ isCreate ? 'Создать контрагента' : 'Редактировать контрагента' }}</h1>
        </section>
      <div class="form__bg">
        <form @submit.prevent>
          <section class="section">
            <h2 class="subtitle">Основная информация</h2>
            <div class="form__inputs">
                <AppSelect
                  title="Организационно правовая форма"
                  :value="{id: contractor.legal_form ? contractor.legal_form.id : null, name: contractor.legal_form ? contractor.legal_form.name : null}"
                  :options="formOptionList"
                  @value-changed="setContractorForm"
                  :disabled="!roleAccessEdit"
                />
                <AppInput
                  title="Краткое наименование"
                  :value="contractor.name"
                  :valid="validation.name"
                  required
                  @value-changed="setContractorName"
                  @got-focus="clearValidation('name')"
                  :disabled="!roleAccessEdit"
                />
                <AppInput
                  title="Полное наименование"
                  :value="contractor.fullName"
                  :valid="validation.fullName"
                  required
                  name="contractorName"
                  @value-changed="setContractorFullName"
                  @got-focus="clearValidation('fullName')"
                  :disabled="!roleAccessEdit"
                />
                <AppSelect
                  title="Статус"
                  required
                  :value="contractor.status"
                  :options="statusOptionList"
                  :valid="validation.status"
                  @open="clearValidation('status')"
                  @value-changed="setContractorStatus"
                  :disabled="!roleAccessEdit"
                />
                <AppTextarea
                  title="Юридический адрес"
                  :value="contractor.legal_address"
                  @value-changed="setContractorRegistrationAddress"
                  :disabled="!roleAccessEdit"
                />
                <AppTextarea
                  title="Фактический адрес"
                  :value="contractor.actual_address"
                  @value-changed="setContractorActualAddress"
                  :disabled="!roleAccessEdit"
                />
                <AppSelect
                  title="Тип контрагента"
                  :value="contractor.type"
                  :options="typeOptionList"
                  required
                  :valid="validation.type"
                  @value-changed="setContractorType"
                  @open="clearValidation('type')"
                  :disabled="!roleAccessEdit"
                />
              </div>
            <h2 class="subtitle">Регистрационные данные</h2>
            <div class="form__inputs">
              <AppInput
                title="ИНН"
                :value="contractor.inn"
                :valid="validation.inn"
                @got-focus="clearValidation('inn')"
                @value-changed="setContractorINN"
                :disabled="!roleAccessEdit"
              />
              <AppInput
                title="ОКПО"
                :value="contractor.okpo"
                :valid="validation.okpo"
                @got-focus="clearValidation('okpo')"
                @value-changed="setContractorOKPO"
                :disabled="!roleAccessEdit"
              />
              <AppInput
                title="ОГРН"
                :value="contractor.ogrn"
                :valid="validation.ogrn"
                @got-focus="clearValidation('ogrn')"
                @value-changed="setContractorOGRN"
                :disabled="!roleAccessEdit"
              />
            </div>
            <h2 class="subtitle">Контактные данные</h2>
            <div class="form__inputs">
              <AppInput
                title="Контактное лицо"
                :value="contractor.contact_fullname"
                @value-changed="setContractorContactInfo"
                :disabled="!roleAccessEdit"
              />
              <AppInput
                title="Телефон"
                :value="contractor.contact_phone"
                @value-changed="setContractorContactPhone"
                :disabled="!roleAccessEdit"
                mask="7##########"
              />
              <AppInput
                title="Email"
                :value="contractor.contact_email"
                @value-changed="setContractorContactEmail"
                :disabled="!roleAccessEdit"
              />
              <AppInput
                title="Должность"
                :value="contractor.contact_position"
                @value-changed="setContractorContactPosition"
                :disabled="!roleAccessEdit"
              />
              <AppInput
                title="Сайт (url)"
                :value="contractor.site_url"
                @value-changed="setContractorContactUrl"
                :disabled="!roleAccessEdit"
              />
            </div>
            <h2 class="subtitle">Платежная информация</h2>
            <div class="form__inputs form__inputs_col-1">
                <AppTextarea
                    title="Реквизиты"
                    :value="contractor.contactRequisites"
                    @value-changed="setContractorRequisites"
                    :disabled="!roleAccessEdit"
                />
            </div>
          </section>

          <section class="section">
              <div class="page__buttons">
                  <div class="page__item">
                      <AppButton
                          :title="isCreate ? 'Создать' : 'Сохранить'"
                          type="main"
                          @click.stop.native="saveContractorInfo"
                          :disabled="!roleAccessEdit"
                      />
                  </div>
                  <div class="page__item">
                      <AppButton
                          title="Отмена"
                          type="alt"
                          @click.stop.native="leavePage"
                      />
                  </div>
              </div>
          </section>
        </form>
      </div>
      <ThePagePreloader v-if="isCreate ? false : isLoading"/>
    </main>
</template>

<script>
import AppInput from '@/components/page/input/AppInput'
import AppButton from '@/components/page/button/AppButton'
import AppSelect from '@/components/page/input/AppSelect'
import AppTextarea from '@/components/page/input/AppTextarea'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import AppBack from '../../components/page/AppBack'

export default {
  name: 'ContractorUpdate',
  data () {
    return {
      isCreate: false
    }
  },
  components: {
    AppTextarea,
    AppSelect,
    AppButton,
    AppInput,
    ThePagePreloader,
    AppBack
  },
  mounted () {
    const id = this.$router.history.current.params.id
    if (id === 'create') {
      this.isCreate = true
      this.$store.dispatch('setContractorUpdateInitialState')
      this.$store.dispatch('getContractorAllOptions')
    } else {
      this.isCreate = false
      this.$store.dispatch('getContractorUpdateInfo', id)
      this.$store.dispatch('getContractorAllOptions')
    }
  },
  destroyed () {
    this.$store.commit('RESET_FORM_CONTRACTOR')
  },
  computed: {
    contractor () {
      return this.$store.getters.getContractorForUpdate
    },
    validation () {
      return this.$store.getters.getContractorUpdateValidation
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    statusOptionList () {
      return this.$store.getters.getContractorStatusList
    },
    formOptionList () {
      return this.$store.getters.getContractorFormList
    },
    typeOptionList () {
      return this.$store.getters.getContractorTypeList
    },
    isLoading () {
      return this.$store.getters.getContractorUpdateIsLoading
    },
    roleAccessEdit () {
      return this.$store.getters.getRoleRightContractors.actions.update
    }
  },
  methods: {
    saveContractorInfo () {
      const id = this.$router.history.current.params.id
      this.$store.dispatch('contractorUpdateSaveInfo', id)
    },
    setContractorForm (form) {
      this.$store.dispatch('contractorUpdateSetForm', form)
    },
    setContractorName (value) {
      this.$store.dispatch('contractorUpdateSetName', value)
    },
    setContractorFullName (value) {
      this.$store.dispatch('contractorUpdateSetFullName', value)
    },
    setContractorStatus (status) {
      this.$store.dispatch('contractorUpdateSetStatus', status)
    },
    setContractorRegistrationAddress (value) {
      this.$store.dispatch(
        'contractorUpdateSetRegistrationAddress',
        value
      )
    },
    setContractorActualAddress (value) {
      this.$store.dispatch('contractorUpdateSetActualAddress', value)
    },
    setContractorType (type) {
      this.$store.dispatch('contractorUpdateSetType', type)
    },
    setContractorINN (value) {
      this.$store.dispatch('contractorUpdateSetINN', value)
    },
    setContractorOKPO (value) {
      this.$store.dispatch('contractorUpdateSetOKPO', value)
    },
    setContractorOGRN (value) {
      this.$store.dispatch('contractorUpdateSetOGRN', value)
    },
    setContractorContactInfo (value) {
      this.$store.dispatch('contractorUpdateSetContactInfo', value)
    },
    setContractorContactPhone (value) {
      this.$store.dispatch('contractorUpdateSetContactPhone', value)
    },
    setContractorContactEmail (value) {
      this.$store.dispatch('contractorUpdateSetContactEmail', value)
    },
    setContractorContactPosition (value) {
      this.$store.dispatch('contractorUpdateSetContactPosition', value)
    },
    setContractorContactUrl (value) {
      this.$store.dispatch('contractorUpdateSetContactUrl', value)
    },
    setContractorRequisites (value) {
      this.$store.dispatch('contractorUpdateSetContactRequisites', value)
    },

    clearValidation (inputName) {
      this.$store.dispatch('contractorUpdateClearValidation', inputName)
    },
    leavePage () {
      this.$store.commit('RESET_FORM_CONTRACTOR')
      this.$router.push({ name: 'ContractorList' })
    }
  }
}
</script>

<style>
</style>
